import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export const Story = () => {
  return (
    <section id="story" className="relative py-20 sm:py-32 bg-[#FFFDFB] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        {/* image collage */}
        <div className="lg:col-span-6 relative h-[360px] sm:h-[560px]">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="absolute top-0 left-0 w-[68%] h-[72%] arch-mask overflow-hidden shadow-[0_20px_45px_rgba(0,0,0,0.12)]"
          >
            <img
              src="https://www.studiomediaagency.com/marketing/donuts-marketing6.webp"
              alt="Don Donuts shop"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, rotate: 4, y: 30 }}
            whileInView={{ opacity: 1, rotate: 4, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="absolute bottom-0 right-0 w-[52%] bg-white p-2 pb-5 shadow-[0_18px_40px_rgba(0,0,0,0.15)]"
          >
            <img
              src="https://www.studiomediaagency.com/marketing/donuts-marketing5.webp"
              alt="Donut details"
              className="w-full aspect-[3/4] object-cover"
              loading="lazy"
            />
            <div className="font-script text-xl text-[#2D2327] mt-2 text-center">est. in the valley</div>
          </motion.div>
          <div className="absolute top-10 right-2 h-20 w-20 rounded-full bg-[#FFD166] grid place-items-center font-serif-display text-2xl text-[#2D2327] shadow-[0_10px_25px_rgba(0,0,0,0.1)] float-anim">
            ✿
          </div>
        </div>

        {/* text */}
        <div className="lg:col-span-6">
          <p className="font-script text-[#FF6392] text-3xl -rotate-2 inline-block">our story,</p>
          <h2 className="font-serif-display text-3xl sm:text-5xl lg:text-6xl text-[#2D2327] tracking-tight mt-2 leading-[1.05]">
            A neighborhood
            <br />
            <span className="italic text-[#FF6392]">donut obsession.</span>
          </h2>
          <p className="mt-7 text-base sm:text-lg text-[#4A3F44] leading-relaxed">
            Don Donuts began with one simple idea: the Rio Grande Valley deserved its own donut shop —
            playful, generous, and a little bit show‑off. Today, we&apos;re rolling, glazing, and topping
            every donut from scratch, every morning, right here in McAllen and San Juan.
          </p>

          <div className="mt-9 grid sm:grid-cols-3 gap-6">
            {[
              { num: "100%", label: "Made in‑house, daily" },
              { num: "4.8★", label: "From 100+ reviews" },
              { num: "956", label: "Proudly RGV" },
            ].map((s) => (
              <div key={s.label} className="rounded-2xl border border-[#FFB3C6]/40 p-5 bg-white/60 backdrop-blur">
                <div className="font-serif-display text-3xl text-[#FF6392]">{s.num}</div>
                <div className="text-sm text-[#4A3F44] mt-1">{s.label}</div>
              </div>
            ))}
          </div>

          <figure className="mt-10 relative pl-10">
            <Quote className="absolute -left-1 top-0 h-8 w-8 text-[#FF6392]" />
            <blockquote className="font-serif-display italic text-xl sm:text-3xl text-[#2D2327] leading-snug">
              “Best donuts in the 956.”
            </blockquote>
            <figcaption className="mt-3 text-sm uppercase tracking-[0.2em] text-[#4A3F44]">
              — Real customer review, DoorDash
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Story;
